var coreSend = require('./messaging/requestSender');
function send(request) {
	return coreSend([request]).then(function(requests) { return requests[0]; });
}

module.exports = send;